export default "__VITE_ASSET__Bg02_h8Y__"